import { Injectable } from '@jack-henry/frontend-utils/di';
import { MessageCenterSearchTermsDto, MessagingcenterClient } from '@treasury/api/channel';
import { MessageCenterCategory } from './message-center-category.entity';

export enum MessageType {
    Received = 2,
    Sent = 3,
    Archived = 4,
    AdvancedSearch = 5,
}

export type Message = {
    id: number;
    messageId: string;
    companyName: string | null;
    companyId: number | null;
    fromToUserName: string;
    fromUserId: number;
    toUserId: number | null;
    categoryId: number;
    subject: string;
    body: string;
    status: string;
    assignedTo: string;
    sentDate: string;
    sentTime: string;
    sentDateTime: string;
    sentMessage: boolean;
    hasAttachment: boolean;
    attachmentNames: Array<string>;
    attachments: Array<string>;
    parentMessage: string | null;
    isArchived: boolean;
    parentMessageId: number | null;
    assignedToUserId: number | null;
    isReply: boolean;
    isSent: boolean;
    messageIdSortValue: string;
};

@Injectable()
export class MessageCenterService {
    constructor(private readonly messagingCenterClient: MessagingcenterClient) {}

    public async getMessageCenterCategories() {
        const response = await this.messagingCenterClient.messagingCenterGetMessageCategories();
        return response.data.map(category => new MessageCenterCategory(category));
    }

    public async getMessageCenterMessages(searchTerms: MessageCenterSearchTermsDto) {
        const response =
            await this.messagingCenterClient.messagingCenterSearchMessagesAll(searchTerms);
        return response.data;
    }
}
